module.exports = __webpack_public_path__ + "c04c0239a291a77625c2bf05b621dfdf.pdf";